(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('closing-contract-reason', {
            parent: 'entity',
            url: '/closing-contract-reason?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.closingContractReason.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reasons.html',
                    controller: 'ClosingContractReasonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('closingContractReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('closing-contract-reason-detail', {
            parent: 'entity',
            url: '/closing-contract-reason/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.closingContractReason.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reason-detail.html',
                    controller: 'ClosingContractReasonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('closingContractReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ClosingContractReason', function($stateParams, ClosingContractReason) {
                    return ClosingContractReason.get({id : $stateParams.id});
                }]
            }
        })
        .state('closing-contract-reason.new', {
            parent: 'closing-contract-reason',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reason-dialog.html',
                    controller: 'ClosingContractReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('closing-contract-reason', null, { reload: true });
                }, function() {
                    $state.go('closing-contract-reason');
                });
            }]
        })
        .state('closing-contract-reason.edit', {
            parent: 'closing-contract-reason',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reason-dialog.html',
                    controller: 'ClosingContractReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClosingContractReason', function(ClosingContractReason) {
                            return ClosingContractReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('closing-contract-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('closing-contract-reason.delete', {
            parent: 'closing-contract-reason',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reason-delete-dialog.html',
                    controller: 'ClosingContractReasonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ClosingContractReason', function(ClosingContractReason) {
                            return ClosingContractReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('closing-contract-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
